
// The plan's files exactly as the PlanCard lists them (Summary of Benefits,
// uploaded plan files for the client's state, the plan's own files, and for
// agents the uploads for other states), without the card's edit/delete/upload
// controls. Rendered under the plans table on /survey/:uid/plans/:pids.
import { mapGetters } from 'vuex'
import { attachmentHref, summaryOfBenefitsLabel } from '~/util/files'

export default {
    props: {
        plan: { type: Object, required: true },
    },
    computed: {
        ...mapGetters(['canAgent', 'planFilesByPlanIdInState', 'planFilesByPlanIdOutState', 'isPlanOriginalFileIgnored']),
        ignored () {
            return this.isPlanOriginalFileIgnored(this.plan)
        },
        files () {
            const inState = this.planFilesByPlanIdInState[this.plan?.id] || []
            return inState.concat(this.plan.files || []).filter(pf => pf.file_s3_path)
        },
        outOfState () {
            return (this.planFilesByPlanIdOutState[this.plan?.id] || []).filter(pf => pf.file_s3_path)
        },
    },
    methods: {
        attachmentHref,
        summaryOfBenefitsLabel,
        states (pf) {
            const list = pf.metadata?.available_states || []
            return list.slice(0, 4).join(', ') + (list.length > 4 ? ', …' : '')
        },
    },
}
